import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSurfingNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M44.704 3.296c-.413-.413-.976-.69-1.532-.875-.585-.195-1.287-.33-2.085-.389-1.6-.117-3.665.07-6.126.795-4.927 1.449-11.49 5.06-19.242 12.812C3.675 27.682 1.276 36.877 1.048 37.852c-.15.65.128 1.186.429 1.486l7.184 7.184c.3.3.836.58 1.486.428.713-.166 5.822-1.493 13.225-6.903 2.581 4.04 8.41 4.69 11.798 1.046l.517-.556c2.676 3.64 8.17 4.118 11.41.635l-2.196-2.043c-2.141 2.3-5.931 1.701-7.257-1.149l-.285-.613a1.5 1.5 0 00-2.458-.389l-1.927 2.072c-2.09 2.247-5.73 1.772-7.206-.838a80.645 80.645 0 006.592-5.93 81.29 81.29 0 002.124-2.203l.345.95c.015.04.032.08.05.119 1.991 4.281 7.256 5.559 10.954 3.086l1.247-.833-1.668-2.494-1.247.833c-2.2 1.472-5.33.714-6.54-1.803l-.88-2.414c4.8-5.7 7.285-10.6 8.428-14.484.723-2.461.911-4.526.794-6.126-.059-.798-.194-1.5-.39-2.085-.185-.556-.46-1.12-.874-1.532zM17.84 17.76c7.494-7.495 13.638-10.782 17.968-12.056 2.167-.638 3.87-.768 5.06-.68.597.043 1.047.14 1.355.243.187.062.292.116.34.144l.022.018c.026.045.083.152.148.347.102.308.2.758.243 1.355.087 1.191-.043 2.893-.68 5.06-1.274 4.33-4.562 10.474-12.056 17.968-9.893 9.894-17.659 12.915-20.037 13.661l-1.95-1.95 26.354-26.355-2.121-2.122L6.13 39.75l-1.952-1.952c.747-2.378 3.768-10.143 13.66-20.036z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSurfingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSurfingNormalLarge;
